/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompanyBillingInformationAddressUpdateRequest } from './';
import {
    ClientCompanyBillingInformationAddressUpdateRequestFromJSON,
    ClientCompanyBillingInformationAddressUpdateRequestFromJSONTyped,
    ClientCompanyBillingInformationAddressUpdateRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyBillingInformationUpdateRequest
 */
export interface ClientCompanyBillingInformationUpdateRequest {
    /**
     * 
     * @type {ClientCompanyBillingInformationAddressUpdateRequest}
     * @memberof ClientCompanyBillingInformationUpdateRequest
     */
    address: ClientCompanyBillingInformationAddressUpdateRequest;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationUpdateRequest
     */
    legalName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationUpdateRequest
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationUpdateRequest
     */
    registrationOfficeInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationUpdateRequest
     */
    registrationNumber: string;
}

/**
 * Check if a given object implements the ClientCompanyBillingInformationUpdateRequest interface.
 */
export function instanceOfClientCompanyBillingInformationUpdateRequest(value: object): value is ClientCompanyBillingInformationUpdateRequest {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('legalName' in value) || value['legalName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    return true;
}

export function ClientCompanyBillingInformationUpdateRequestFromJSON(json: any): ClientCompanyBillingInformationUpdateRequest {
    return ClientCompanyBillingInformationUpdateRequestFromJSONTyped(json, false);
}

export function ClientCompanyBillingInformationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyBillingInformationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': ClientCompanyBillingInformationAddressUpdateRequestFromJSON(json['address']),
        'legalName': json['legalName'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'registrationOfficeInformation': json['registrationOfficeInformation'] == null ? undefined : json['registrationOfficeInformation'],
        'registrationNumber': json['registrationNumber'],
    };
}

export function ClientCompanyBillingInformationUpdateRequestToJSON(value?: ClientCompanyBillingInformationUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'address': ClientCompanyBillingInformationAddressUpdateRequestToJSON(value['address']),
        'legalName': value['legalName'],
        'vatNumber': value['vatNumber'],
        'registrationOfficeInformation': value['registrationOfficeInformation'],
        'registrationNumber': value['registrationNumber'],
    };
}

